// Canadian provinces and territories (QUAL-003.1). Posts store the two-letter code.
// Keep in sync with PROVINCES in functions/_lib/validate.js.
export const PROVINCES = [
  { code: 'AB', name: 'Alberta' },
  { code: 'BC', name: 'British Columbia' },
  { code: 'MB', name: 'Manitoba' },
  { code: 'NB', name: 'New Brunswick' },
  { code: 'NL', name: 'Newfoundland and Labrador' },
  { code: 'NS', name: 'Nova Scotia' },
  { code: 'NT', name: 'Northwest Territories' },
  { code: 'NU', name: 'Nunavut' },
  { code: 'ON', name: 'Ontario' },
  { code: 'PE', name: 'Prince Edward Island' },
  { code: 'QC', name: 'Quebec' },
  { code: 'SK', name: 'Saskatchewan' },
  { code: 'YT', name: 'Yukon' },
];

const ALIASES = { QB: 'QC', PQ: 'QC', PEI: 'PE', NFLD: 'NL', NF: 'NL', YK: 'YT' };

// Maps stored values like "BC ", "bc", "British Columbia" or "QB" to a code, or '' if unknown.
export function toProvinceCode(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  const upper = raw.toUpperCase().replace(/\./g, '');
  const byCode = PROVINCES.find((p) => p.code === upper);
  if (byCode) return byCode.code;
  if (ALIASES[upper]) return ALIASES[upper];
  const byName = PROVINCES.find((p) => p.name.toUpperCase() === upper);
  return byName ? byName.code : '';
}
